export default "__VITE_ASSET__DdUHKJ9S__"